module.exports = __webpack_public_path__ + "img/bingchong.8eff240f.svg";